import { z } from 'zod';

// * Define contract schemas using zod
export const InboxSchema = z.object({
  id: z.string(),
  identifier: z.string(),
  name: z.string(),
  createdBy: z.string(),
});

export const InboxSchemaCreate = z.object({
  name: z.string(),
});

export const InboxAgentSchema = z.object({
  identifier: z.string(),
  name: z.string(),
  isAgentAssigned: z.boolean(),
});
